+function($, window, document) {
	'use strict';
	
	//private methods
	var now = Date.now || function() {
	    return new Date().getTime();
	};
	
	/**
	 * Constructor
	 * 
	 * @param {object} html object to attach this plugin
	 * @param {object} settings object passed into this plugin
	 * return void
	 */
	var RefineProduct = function(element, options) {
		this.options = options;
		this.$element = $(element);
		this.$elementPrice = this.$element.find('#priceRange');
		this.$productListing = $('.product-items');
		this.$filterBar = $('.products-filter-bar');
		this.$elementRefine = $('.refine');
		this.isMobile = false;
		this.disableScrollLoader = false;
		
		this.filters = [];
		this.priceRange = {min: this.options.priceMin, max: this.options.priceMax};
		this.page = 1;
		
		//initialize this plugin
		this.initialize();
	};
	
	//default settings for this plugin
	RefineProduct.DEFAULTS = {
		urlRefreshProducts: null,
		urlRefreshFilters: null,
		urlScrollLoad: null,
		categoryId: 0,
		priceType: 'double',
		perPage: 10,
		priceMin: 0,
		priceMax: null,
		pricePrefix: '$'
	};
	
	//debounce helper
	RefineProduct.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;

	    var later = function() {
	    	var last = now() - timestamp;

	    	if (last < wait && last >= 0) {
	    		timeout = setTimeout(later, wait - last);
	    	} else {
	    		timeout = null;
	    		if (!immediate) {
	    			result = func.apply(context, args);
				  
	    			if (!timeout) context = args = null;
	    		}
	    	}
	    };

	    return function() {
	    	context = this;
	    	args = arguments;
	    	timestamp = now();
	    	var callNow = immediate && !timeout;
	    	
	    	if (!timeout) timeout = setTimeout(later, wait);
	    	
    		if (callNow) {
    			result = func.apply(context, args);
    			context = args = null;
    		}
		
    		return result;
	    };
	};
	
	/**
	 * Init this plugin
	 * 
	 * @access public
	 * @return void
	 */
	RefineProduct.prototype.initialize = function() {
		this.detectMobile();
		
		//init filters data
		this.initFilters();
		
		//init price range
		this.initPriceRange();
		
		//toggle group box
		this.observeToggleGroup();
		
		//click filter action
		this.observeClickFilter();
		
		//clear all action
		this.observeClearAll();
		
		//clear specific group action
		this.observerSingleClear();
		
		//init pagination
		if (!this.isMobile) {
			this.initPagination();
		}
		
		//init filter bar for mobile
		if (this.isMobile) {
			this.initFilterBar();
		}
		
		//init scroll to load products for mobile
		// if (this.isMobile) {
			this.initScrollLoader();
		// }
	};
	
	
	/**
	 * Responsible for initing filters data
	 * 
	 * @access public
	 * @return void
	 */
	RefineProduct.prototype.initFilters = function() {
		var scope = this;
		
		//init filters
		$('.refine-group').each(function() {
			var group = $(this).data('group');
			
			if ( !group) {
				group = 0;
			}
			
			scope.filters.push({group: group, filters: []});
		});
	};
	
	/**
	 * Responsible for initing filter bar
	 * 
	 * @access public
	 * @return void
	 */
	RefineProduct.prototype.initFilterBar = function() {
		var scope = this,
			mask = $('<div class="filter-mask"></div>').appendTo($(document.body));
		
		//show filters
		this.$productListing.on('click', '.btn-refine', function(event) {
			event.preventDefault();
			
			scope.disableScrollLoader = true;
			
			scope.$elementRefine.show();
			mask.show();
			
			return false;
		});
		
		//cancel
		this.$element.on('click', '.refine-footer > button:first-child', function(event) {
			event.preventDefault();
			
			scope.disableScrollLoader = false;
			
			scope.$elementRefine.hide();
			mask.hide();
			
			scope.reset();
			
			return false;
		});
		
		//apply
		this.$element.on('click', '.refine-footer > button:last-child', function(event) {
			event.preventDefault();
			
			scope.disableScrollLoader = false;
			
			scope.$elementRefine.hide();
			mask.hide();
			
			scope.refresh();
			
			return false;
		});
		
		
	};
	
	/**
	 * Responsible for toggling the state of apply button in the mobile device
	 * 
	 * @access public
	 * @return void
	 */
	RefineProduct.prototype.toggleApplyButton = function() {
		var btnApply = $('.refine-footer > button:last-child');
		
		if (this.isEmpty()) {
			if ( ! btnApply.hasClass('disabled')) {
				btnApply.addClass('disabled');
			}
		}else {
			btnApply.removeClass('disabled');
		}
	};
	
	/**
	 * Responsible for initing price range filter
	 * 
	 * @access public
	 * @return void
	 */
	RefineProduct.prototype.initPriceRange = function() {
		var scope = this;
		
		this.$elementPrice.ionRangeSlider({
			type: scope.options.priceType,
			min: scope.options.priceMin,
			max: scope.options.priceMax,
			prefix: scope.options.pricePrefix,
			onFinish: function(obj) {
				scope.priceRange.min = obj.from;
				scope.priceRange.max = obj.to;
				
				scope.$elementPrice.parents('.refine-group').find('.clear-price').show();
				
				if (!scope.isMobile) {
					scope.refresh();
				}else {
					scope.toggleApplyButton();
				}
			}
		});
	};
	
	/**
	 * Initialize scroll to load more products functionality
	 * 
	 * @access public
	 * @return void
	 */
	RefineProduct.prototype.initScrollLoader = function() {
		var $window = $(window),
			scope = this;
		
		this.updateScrollerLoaderState();
		
		$window.on('scroll', RefineProduct.debounce(function() {
			if (scope.disableScrollLoader) {
				return false;
			}
			
			if($window.scrollTop() > $(document).height() - $window.height() - 200) {
				scope.page++;
				
				scope.appendProducts();
		    }
		}, 50));
	};
	
	/**
	 * Update scroller loader state
	 * 
	 * @access public
	 * @return void
	 */
	RefineProduct.prototype.updateScrollerLoaderState = function() {
		if ($('.product-items .item').length < this.options.perPage) {
			this.disableScrollLoader = true;
		}
	}
	
	/**
	 * Append products into list
	 * 
	 * @access public
	 * @return void
	 */
	RefineProduct.prototype.appendProducts = function() {
		var deffered,
			scope = this,
			params = {cid: this.options.categoryId, filters: this.filters};
		
		$('.product-items').css('opacity', 0.5);
		
		//show ajax notification
		$.publish('showajaxnotification.sn');
		
		if (this.options.priceMin != this.priceRange.min || this.options.priceMax != this.priceRange.max) {
			params.min = this.priceRange.min;
			params.max = this.priceRange.max;
		}
		
		if (this.page > 1) {
			params.p = this.page;
		}
		
		deffered = $.get(this.options.urlScrollLoad, params);
			
		deffered.done(function(content) {
			if (content.indexOf('items') !== -1) {
				var productItems = scope.$element.next('.product-items');
				
				productItems.append(content);
				
				$('.scroll-hand').show();
			//no more products
			}else {
				scope.disableScrollLoader = true;
				$('.scroll-hand').hide();
			}
		});
		
		deffered.always(function() {
			$.publish('hideajaxnotification.sn');
			
			$('.product-items').css('opacity', 1);
		});
	};
	
	/**
	 * Responsible for resetting filters
	 * 
	 * @access public
	 * @return void
	 */
	RefineProduct.prototype.reset = function() {
		$.each(this.filters, function(index, item) {
			item.filters = [];
		});
		
		$('.refine-items a.checked').removeClass('checked').addClass('unchecked');
		$('.refine .clear').hide();
		$('.refine .clear-all').hide();
		$('.refine .clear-price').hide();
		
		this.page = 1;
		
		//restore price range box
		this.restorePriceRange();
		
		//toggle apply button state for mobile device
		if (this.isMobile) {
			this.toggleApplyButton();
			this.$elementRefine.hide();
			$('.filter-mask').hide();
		}
		
		//refresh products & filters
		this.refresh();
	};
	
	/**
	 * Responsible for handling interaction when user click clear all button
	 * 
	 * @access public
	 * @return void
	 */
	RefineProduct.prototype.observeClearAll = function() {
		var scope = this;
		
		this.$element.on('click', '.clear-all', function(event) {
			event.preventDefault();
			
			scope.reset();
			
			return false;
		});
	};
	
	/**
	 * Responsible for handling interaction when user click clear button in each group
	 * 
	 * @access public
	 * @return void
	 */
	RefineProduct.prototype.observerSingleClear = function() {
		var scope = this;
		
		//clear filters
		this.$element.on('click', '.clear', function(event) {
			event.preventDefault();
			
			var groupItem = $(this).parents('.refine-group'),
				groupId = groupItem.data('group');
			
			$.each(scope.filters, function(index, item) {
				if (item.group == groupId) {
					item.filters = [];
					
					return false;
				}
			});
			
			groupItem.find('a.checked').removeClass('checked').addClass('unchecked');
			
			$(this).hide();
			
			//restore page
			scope.page = 1;
			
			if (scope.isEmpty()) {
				$('.refine .clear-all').hide();
			}
			
			//refresh products & filters
			if (!scope.isMobile) {
				scope.refresh();
			}else {
				scope.toggleApplyButton();
			}
			
			return false;
		});
		
		//clear price range
		this.$element.on('click', '.clear-price', function(event) {
			event.preventDefault();
			
			//restore page
			scope.page = 1;
			
			//restore price range box
			scope.restorePriceRange();
			
			//refresh products & filters
			if (!scope.isMobile) {
				scope.refresh();
			}else {
				scope.toggleApplyButton();
			}
			
			$(this).hide();
			
			return false;
		});
	};
	
	/**
	 * Responsible for restoring the price range to the original state
	 * 
	 * @access public
	 * @return void
	 */
	RefineProduct.prototype.restorePriceRange = function() {
		this.priceRange = {min: this.options.priceMin, max: this.options.priceMax};
		this.$elementPrice.data('ionRangeSlider').reset();
	};
	
	/**
	 * Responsible for handling interaction when user click toggle button of filter group
	 * 
	 * @access public
	 * @return void
	 */
	RefineProduct.prototype.observeToggleGroup = function() {
		this.$element.on('click', '.refine-header a.toggle', function(event) {
			event.preventDefault();
			
			var toggleIcon = $(this).children('[class^="icon-"]');
			
			$(this).parents('.refine-header').next('.refine-items').slideToggle(100);
			
			if (toggleIcon.hasClass('icon-caret-down')) {
				toggleIcon.removeClass('icon-caret-down').addClass('icon-caret-up');
			}else {
				toggleIcon.removeClass('icon-caret-up').addClass('icon-caret-down');
			}
			
			return false;
		});
	};
	
	/**
	 * Responsible for performing interaction when user click the filter item
	 * 
	 * @access public
	 * @return void
	 */
	RefineProduct.prototype.observeClickFilter = function() {
		var scope = this;
		
		this.$element.on('click', '.refine-items a', function(event) {
			event.preventDefault();
			
			var filterItem = $(this),
				filterId = filterItem.data('filter'),
				groupItem = filterItem.parents('.refine-group'),
				groupId = groupItem.data('group'),
				clearBtn = groupItem.find('.clear');
			
			//is current filter is disabled
			if (filterItem.parent().hasClass('disabled')) {
				return false;
			}
			
			if (filterItem.hasClass('unchecked')) {
				scope.addFilter(groupId, filterId, clearBtn);
				
				filterItem.removeClass('unchecked').addClass('checked');
			}else {
				scope.removeFilter(groupId, filterId, clearBtn);
				
				filterItem.removeClass('checked').addClass('unchecked');
			}
			
			if (scope.isEmpty()) {
				scope.$element.find('.clear-all').hide();
			}else {
				scope.$element.find('.clear-all').show();
			}
			
			//refresh products & filters
			if (!scope.isMobile) {
				scope.refresh();
			}else {
				scope.toggleApplyButton();
			}
			
			return false;
		});
	};
	
	/**
	 * Refresh filters
	 * 
	 * @access public
	 * @return void
	 */
	RefineProduct.prototype.refreshFilters = function() {
		var deffered,
			scope = this,
			params = {cid: this.options.categoryId, filters: this.filters};
		
		if (this.options.priceMin != this.priceRange.min || this.options.priceMax != this.priceRange.max) {
			params.min = this.priceRange.min;
			params.max = this.priceRange.max;
		}
		
		deffered = $.get(this.options.urlRefreshFilters, params);
		
		deffered.done(function(result) {
			if (result.success) {
				$.each(result.filters, function(key, group) {
					$.each(group.filters, function(index, filter) {
						var filterItem = $('.refine a[data-filter="' + filter.id + '"]').parent();
						
						if (filter.enabled) {
							filterItem.removeClass('enabled disabled').addClass('enabled');
						}else {
							filterItem.removeClass('enabled disabled').addClass('disabled');
						}
					});
				})
			}
		});
	};
	
	/**
	 * Refresh products
	 * 
	 * @access public
	 * @return void
	 */
	RefineProduct.prototype.refreshProducts = function() {
		var deffered,
			scope = this,
			params = {cid: this.options.categoryId, filters: this.filters};
		
		$('.product-items').css('opacity', 0.5);
		
		//show ajax notification
		$.publish('showajaxnotification.sn');
		
		if (this.options.priceMin != this.priceRange.min || this.options.priceMax != this.priceRange.max) {
			params.min = this.priceRange.min;
			params.max = this.priceRange.max;
		}
		
		if (this.page > 1) {
			params.p = this.page;
		}
		
		deffered = $.get(this.options.urlRefreshProducts, params);
			
		deffered.done(function(content) {
			scope.$element.next('.product-items').empty().html(content);
			
			if (scope.isMobile) {
				scope.updateScrollerLoaderState();
			}
		});
		
		deffered.always(function() {
			$.publish('hideajaxnotification.sn');
			
			$('.product-items').css('opacity', 1);
		});
	};
	
	/**
	 * Refresh products and filters
	 * 
	 * @access public
	 * @return void
	 */
	RefineProduct.prototype.refresh = function() {
		this.refreshProducts();
		this.refreshFilters();
	};
	
	/**
	 * Add the checked filter from specific group
	 * 
	 * @access public
	 * @param {int} checked group id
	 * @param {int} checked filter id
	 * @param {object} clear button
	 * @return void
	 */
	RefineProduct.prototype.removeFilter = function(groupId, filterId, clearBtn) {
		$.each(this.filters, function(index, item) {
			if (item.group == groupId) {
				$.each(item.filters, function(key, filter) {
					if (filter == filterId) {
						item.filters.splice(key, 1);
						
						if (item.filters.length == 0) {
							clearBtn.hide();
						}
						
						return false;
					}
				});
				
				
				return false;
			}
		});
	};
	
	/**
	 * Init pagination
	 * 
	 * @access public
	 * @return void
	 */
	RefineProduct.prototype.initPagination = function() {
		var scope = this;
		
		this.$productListing.on('click', '.pagination a', function(event) {
			 event.preventDefault();
			 
			 var $link = $(this),
			 	 page;
			 
			 if ( ! $link.parents('li').hasClass('active')) {
				 if ($link.find('.icon-chevron-right').length > 0) {
					 scope.page++;
				 }else if ($link.find('.icon-chevron-left').length > 0) {
					 scope.page--;
				 }else {
					 scope.page = $(this).text();
				 }
				 
				 scope.refreshProducts();
			 }
			 
			 return false;
		});
	};
	
	/**
	 * Add the checked filter into specific group
	 * 
	 * @access public
	 * @param {int} checked group id
	 * @param {int} checked filter id
	 * @param {object} clear button
	 * @return void
	 */
	RefineProduct.prototype.addFilter = function(groupId, filterId, clearBtn) {
		$.each(this.filters, function(index, item) {
			if (item.group == groupId) {
				item.filters.push(filterId);
				
				clearBtn.show();
				
				return false;
			}
		});
	};
	
	/**
	 * Responsible for detecting device
	 * 
	 * @access public
	 * @return void
	 */
	RefineProduct.prototype.detectMobile = function() {
		if ($(window).width() <= 992) {
			this.isMobile = true;
		}
	};
	
	/**
	 * Check whether there isn't any filter checked
	 * 
	 * @access public
	 * @return {boolean}
	 */
	RefineProduct.prototype.isEmpty = function() {
		var empty = true;
		
		$.each(this.filters, function(index, item) {
			if (item.filters.length > 0) {
				empty = false;
				
				return false;
			}
		});
		
		if (this.priceRange.min != this.options.priceMin || this.priceRange.max != this.options.priceMax) {
			empty = false;
		}
		
		return empty;
	};
	
	/**
	 * Work as a plugin of jquery
	 * 
	 * @access private
	 * @param {object} settings object that will be merged with default settings
	 * @return void
	 */
	function Plugin(option) {
	    return this.each(function () {
    		var $this   = $(this),
    			data    = $this.data('sn.RefineProduct'),
    			options = $.extend({}, RefineProduct.DEFAULTS, typeof option == 'object' && option);
	      
	      if ( ! data) {
	    	  $this.data('sn.RefineProduct', (data = new RefineProduct(this, options)));  
	      } 
	      
	      if (typeof option == 'string') {
	    	  data[option]();  
	      } 
	    });
	}
	
	var old = $.fn.RefineProduct;
	
	//attach this plugin into jquery prototype
	$.fn.RefineProduct = Plugin;
	
	//fix the constructor property
	$.fn.RefineProduct.Constructor = RefineProduct;
	
	//clear conflict
	$.fn.RefineProduct.noConflict = function () {
	    $.fn.RefineProduct = old;
	    return this;
	};
}(jQuery, window, document);